import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postProjectIngList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.list.ing,
      method: 'post',
      data: paramsToFormData(params),
    }),          
  postProjectCloseList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.list.close,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectExcelList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.list.excel,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectSeminarList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.seminar.list,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectSeminarExcelList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.seminar.listexcel,
      method: 'post',
      data: paramsToFormData(params),
    }),       
  postProjectPmlIngList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.pml.list.ing,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectPmlCloseList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.pml.list.close,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postProjectPmlExcelList: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.pml.list.excel,
      method: 'post',
      data: paramsToFormData(params),
    }),       
  postProjectInsert: (params: B2cInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectUpdate: (params: B2cInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.update,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postProjectMemoUpdate: (params: B2cInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.update_memo,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postPmlInsert: (params: B2cPmlInfoDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.pml.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postPmlUpdate: (params: B2cPmlInfoDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.pml.update,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectClose: (params: B2cInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.close,
      method: 'post',
      data: paramsToFormData(params),
    }),           
  postProjectDrop: (params: ProjectReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.drop,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectDelete: (params: ProjectReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.delete,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectCopy: (params: B2cInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.copy,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectInfo: (params: ProjectReqDto): Promise<B2cInfoResDto> =>
    request({
      url: endpoints.b2c.info,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postPmlInfo: (params: ProjectReqDto): Promise<B2cInfoResDto> =>
    request({
      url: endpoints.b2c.pml.info,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectOperatorInfo: (params: ProjectInfoReqDto): Promise<ProjectScheduleInfoResDto> =>
    request({
      url: endpoints.b2c.operator.info,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectOperatorSave: (params: ProjectOperatorSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.operator.save,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectOperatorDelete: (params: ProjectOperatorDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.operator.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postProjectScheduleInfo: (params: ProjectInfoReqDto): Promise<ProjectScheduleInfoResDto> =>
    request({
      url: endpoints.b2c.schedule.info,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postProjectScheduleInsert: (params: ProjectScheduleSaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.b2c.schedule.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectScheduleUpdate: (params: ProjectScheduleSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.schedule.update,
      method: 'post',
      data: paramsToFormData(params),
    }),        
  postProjectScheduleDelete: (params: B2cDeleteReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.schedule.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postProjectScheduleCheck: (params: ProjectScheduleCheckReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.schedule.check,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postStudentList: (params: CommonIdReqDto): Promise<StudentInfoResDto> =>
    request({
      url: endpoints.b2c.student.list,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postStudentNotAttendList: (params: CommonIdReqDto): Promise<StudentInfoResDto> =>
    request({
      url: endpoints.b2c.student.non_attend_list,
      method: 'post',
      data: paramsToFormData(params),
    }),       
  postStudentInfo: (params: CommonIdReqDto): Promise<StudentDtailResDto> =>
    request({
      url: endpoints.b2c.student.info,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postStudentInsert: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.add,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postStudentUpdate: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.update,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postStudentDelete: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postStudentPutoff: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.putoff,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postStudentReinforce: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.reinforce,
      method: 'post',
      data: paramsToFormData(params),
    }),      
  postStudentPenalty: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.penalty,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postStudentAttend: (params: StudentAttendSaveRepDto): Promise<StudentAttendResDto> =>
    request({
      url: endpoints.b2c.student.attend,
      method: 'post',
      data: paramsToFormData(params),
    }),            
  postStudentRestore: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.restore,
      method: 'post',
      data: paramsToFormData(params),
    }),         
  postUploadStudents: (params: AppExcelReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.upload,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postNextLectureList: (params: NextLectureListRepDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.next_lecture,
      method: 'post',
      data: paramsToFormData(params),
    }),           
  postGroupDailyList: (params: CommonIdReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.daily_list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postStudentMailContent: (params: StudentMailContentReqDto): Promise<StudentMailContentResDto> =>
    request({
      url: endpoints.b2c.student.mail,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postStudentMailSend: (params: StudentMailContentDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.mailsend,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postStudentMultiMailSend: (params: StudentMultiMailContentDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.mailsendmulti,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postStudentMultiSmsSend: (params: StudentMultiSmsContentDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.smssendmulti,
      method: 'post',
      data: paramsToFormData(params),
    }),      
  postStudentEMailContent: (params: StudentMailContentReqDto): Promise<StudentEMailContentResDto> =>
    request({
      url: endpoints.b2c.student.email,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postStudentEMailSend: (params: StudentEMailContentDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.mailsend,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postStudentMultiEMailSend: (params: StudentMultiEMailContentDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.student.mailsendmulti,
      method: 'post',
      data: paramsToFormData(params),
    }),      
  postSeminarStudentList: (params: CommonIdReqDto): Promise<StudentInfoResDto> =>
    request({
      url: endpoints.b2c.seminar.student.list,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postSeminarStudentInsert: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.seminar.student.add,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postSeminarStudentUpdate: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.seminar.student.update,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postSeminarStudentDelete: (params: StudentSaveRepDto): Promise<CommonResDto> =>
    request({
      url: endpoints.b2c.seminar.student.delete,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postStudentHistoryList: (params: HistoryListReqDto): Promise<StudentHistoryListDto> =>
    request({
      url: endpoints.b2c.student.history,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postQuotationInsert: (params: QuotationInfoDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.b2c.quotation.insert,
      method: 'post',
      data: paramsToFormData(params),
    }), 

};
